"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.options = exports.defaultOptions = void 0;
const api_derive_1 = require("@acala-network/api-derive");
const types_1 = require("@acala-network/types");
const runtime_1 = require("./runtime");
exports.defaultOptions = {
    types: types_1.types,
    rpc: types_1.rpc
};
const options = ({ rpc = {}, runtime = {}, signedExtensions, types = {}, typesAlias = {}, typesBundle = {}, ...otherOptions } = {}) => ({
    types: {
        ...types_1.types,
        ...types_1.lookupTypes,
        ...types
    },
    rpc: {
        ...types_1.rpc,
        ...rpc
    },
    typesAlias: {
        ...types_1.typesAlias,
        ...typesAlias
    },
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    derives: {
        ...api_derive_1.derive
    },
    typesBundle: {
        ...typesBundle,
        spec: {
            ...typesBundle.spec,
            acala: {
                ...types_1.typesBundle?.spec?.acala,
                ...typesBundle?.spec?.acala
            },
            mandala: {
                ...types_1.typesBundle?.spec?.mandala,
                ...typesBundle?.spec?.mandala
            },
            karura: {
                ...types_1.typesBundle?.spec?.karura,
                ...typesBundle?.spec?.mandala
            }
        }
    },
    signedExtensions: {
        ...types_1.signedExtensions,
        ...signedExtensions
    },
    runtime: {
        ...runtime_1.runtime,
        ...runtime
    },
    ...otherOptions
});
exports.options = options;
